import _default from './Search';
export { _default as default };